import { render, staticRenderFns } from "./UiCamera.vue?vue&type=template&id=63c6ce36&scoped=true"
import script from "./UiCamera.vue?vue&type=script&lang=js"
export * from "./UiCamera.vue?vue&type=script&lang=js"
import style0 from "./UiCamera.vue?vue&type=style&index=0&id=63c6ce36&prod&scoped=true&lang=css"
import style1 from "./UiCamera.vue?vue&type=style&index=1&id=63c6ce36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6ce36",
  null
  
)

export default component.exports